import {useRef, useState} from "react";

import {getArrayFromMap} from '../../../../common/utils/index';


const RulesDesktopSubmenu = (
    {
        menuItem,
        activeArticleId,
        setActiveArticleId,
        setHoveredMenu,
    }
) => {
    const [expandedSubmenu, setExpandedSubmenu] = useState(null);

    const subSubRef = useRef(null);
    const ref = useRef(null);

    const expandedMenuItems = expandedSubmenu ?
        menuItem.children.get(expandedSubmenu)?.children : null;

    return (
        <div className="rules__submenu" ref={ref}>
            <div className="rules__submenu-list">
                { getArrayFromMap(menuItem.children)
                    .map(((subMenuItem) => (
                        <div
                            className="rules__menu-item-label rules__menu-item-label--sub"
                            onMouseEnter={(e) => {
                                setExpandedSubmenu(null);
                                if (subMenuItem.children?.size) {
                                    setExpandedSubmenu(subMenuItem.id);
                                    subSubRef.current.style.top = `${e.target.offsetTop}px`;
                                }
                            }}
                            onMouseLeave={() => {
                                if (!subMenuItem.children.size) {
                                    setExpandedSubmenu(null);
                                }
                            }}
                            onClick={() => {
                                if(!subMenuItem.children?.size) {
                                    setHoveredMenu(null);
                                    setExpandedSubmenu(null);
                                    setActiveArticleId(subMenuItem.article_id);
                                }
                            }}
                            key={subMenuItem.id}
                        >
                            {subMenuItem.title}
                        </div>
                    )))
                }
            </div>
            <div className="rules__submenu-children" ref={subSubRef}>
                { expandedMenuItems?.size ?
                    <div className="rules__submenu-list">
                        { getArrayFromMap(expandedMenuItems).map(item => (
                            <div
                                className={`rules__menu-item-label rules__menu-item-label--sub${activeArticleId === item.article_id ? ' rules__menu-item-label--active' : ''}`}
                                onClick={() => {
                                    setHoveredMenu(null);
                                    setExpandedSubmenu(null);
                                    setActiveArticleId(item.article_id);
                                }}
                                key={item.id}
                            >
                                {item.title}
                            </div>
                        ))}
                    </div>
                    : null
                }
            </div>
        </div>
    );
}

export const RulesDesktopMenu = (
    {
        menuItems,
        activeArticleId,
        setActiveArticleId,
    }
) => {
    const [hoveredMenu, setHoveredMenu] = useState(null);

    return (
        <>
            { getArrayFromMap(menuItems)
                .map(((menuItem) => {
                    return <div
                        className={`rules__menu-item${activeArticleId === menuItem.article_id ? ' rules__menu-item--active' : ''}`}
                        onMouseEnter={() => setHoveredMenu(menuItem.id)}
                        onMouseLeave={() => setHoveredMenu(null)}
                        onClick={() => {
                            if(!menuItem.children?.size) {
                                setActiveArticleId(menuItem.article_id);
                            }
                        }}
                        key={menuItem.id}
                           >
                        <p className="rules__menu-item-label">
                            {menuItem.title}
                        </p>
                        {menuItem.children?.size && menuItem.id === hoveredMenu ?
                            <RulesDesktopSubmenu
                                menuItem={menuItem}
                                activeArticleId={activeArticleId}
                                setActiveArticleId={setActiveArticleId}
                                setHoveredMenu={setHoveredMenu}
                            />
                            : null
                        }
                    </div>
                }))}
        </>
    );
};